import { render, staticRenderFns } from "./RepresentativeTransferRequests.vue?vue&type=template&id=23fabdd9&"
import script from "./RepresentativeTransferRequests.vue?vue&type=script&lang=js&"
export * from "./RepresentativeTransferRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports